var checkbox = document.getElementById("ToggleDarkMode");

if (checkbox) {
// Check storage if dark mode was on or off
	if (sessionStorage.getItem("mode") === "dark") {
		applyDarkMode();
	} else {
		removeDarkMode();
	}

// If the checkbox state is changed, run a function
	checkbox.addEventListener("change", function () {
		if (checkbox.checked) {
			applyDarkMode();
		} else {
			removeDarkMode();
		}
	});
}
// Function to apply dark mode
function applyDarkMode() {
	document.documentElement.setAttribute("data-bs-theme", "dark");
	checkbox.checked = true;
	sessionStorage.setItem("mode", "dark");
}

// Function to remove dark mode
function removeDarkMode() {
	document.documentElement.removeAttribute("data-bs-theme");
	checkbox.checked = false;
	sessionStorage.setItem("mode", "light");
}
